import React, { useState, useEffect, useCallback } from "react";
import useStyles from "./style";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

// Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

// Services
import servicetypeapi from "Services/Servicefare";

const ServiceDelete = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [servicename, setservicename] = useState(null);

  // Fetch Service Details
  const getDetails = useCallback(() => {
    if (!id) return;
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setservicename(res?.data?.data?.[0]?.serviceTypeId?.serviceName);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    servicetypeapi.getServicefarebyid(id).then(onSuccess, onFailure);
  }, [id, dispatch]);

  useEffect(() => {
    if (openDialog) {
      getDetails();
    }
  }, [openDialog, getDetails]);

  const handleDeleteServicetype = () => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Service Fare Deleted Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        handleClose();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to Delete data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    servicetypeapi.deleteServicefare(id).then(onSuccess, onFailure);
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleClose}
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle className={classes.dialogTitle}>Delete Service Fare Model</DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.dialogContentText}>
          Are you sure you want to delete the fare model for{" "}
          <strong>{servicename || "this service"}</strong>? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className={classes.cancelButton} onClick={handleClose}>
          Cancel
        </Button>
        <Button className={classes.deleteButton} onClick={handleDeleteServicetype} autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceDelete;
